// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2AFRF","errorLogs":"styles_errorLogs__Ft4mb"};